'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  margin: auto;
  overflow-y: auto;
  display: flex;
  align-items: flex-end;
`;

export const grid = css`
  display: grid;
  background: white;
  position: relative;
  overflow-y: auto;
  max-height: 100%;
  padding: 0.5rem;
  border-radius: 0.75rem;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  grid-template-areas:
    'image'
    'title'
    'info';
  gap: 1rem;
  width: fit-content;
  @media screen and (width > ${theme.sizes.screens.sm}) {
    grid-template-columns: clamp(150px, 250px, 300px) 1fr;
    grid-template-rows: auto 1fr;
    width: 100%;
    grid-template-areas:
      'image title'
      'image info';
  }
`;

export const image = css`
  grid-area: image;
  position: relative;
  margin: auto;
  width: 100%;
  min-height: 150px;
  max-height: 175px;
  background-color: ${theme.colors.peoople['gris-claro']};
  border-radius: 0.5rem;
  overflow: hidden;
  img {
    object-fit: cover;
    width: 100%;
  }
`;

export const bookmark = css`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
`;

export const title = css`
  grid-area: title;
`;

export const name = css`
  font-weight: 600;
`;

export const distance = css`
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.peoople['gris-medio']};
`;

export const info = css`
  grid-area: info;
`;

export const address = css`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.peoople['gris-medio-claro']};
  text-decoration: underline;
  &:hover {
    color: ${theme.colors.peoople['gris-medio']};
  }
`;

export const close = css`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
`;
